import { useEffect } from 'react';

var useClickOutside = function useClickOutside(ref, callback, options) {
  useEffect(function () {
    if (ref.current) {
      var handleClickOutside = function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target) && typeof callback === 'function') {
          callback(event);
        }
      };

      document.addEventListener('click', handleClickOutside, options);
      return function () {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [callback, ref, options]);
};

export { useClickOutside as default };
//# sourceMappingURL=index.js.map
